import { Routes, Route, Navigate } from "react-router-dom";
import { PATHS } from "constants/index";
import Dashboard from "page/DashBoard";
import DomainAnalysis from "page/DomainAnalysis"
import BlockchainCertification from "page/BlockchainCertification"
import AddTradeMark from "page/AddTradeMark";
import Schedule from "page/Schedule";
import TrawlSection from "page/TrawlSection";
import GapFill from "page/GapFill";
import SpecificationManagement from "page/SpecificationManagement";
import BimiAnalysis from "page/Bimi/Children/BimiAnalysis";
import LicensingDashboard from "page/Licensing/Children/Dashboard";
import ReminderSystem from "page/Licensing/Children/ReminderSystem";
import SmartContract from "page/Licensing/Children/SmartContract";
import TrademarkLicense from "page/Licensing/Children/TrademarkLicense";
import CurrencyAnalysis from "page/ValuationCalculator/Children/CurrencyAnalysis";
import EnhancedValuation from "page/ValuationCalculator/Children/EnhancedValuation";
import ComprehensiveValuation from "page/ValuationCalculator/Children/ComprehensiveValuation";
import Product from "page/DetailedValuation/Children/Product";
import EBIDTAImpactAnalysis from "page/DetailedValuation/Children/EBIDTAImpactAnalysis";
import ConflictCheck from "page/ConflictCheck";
import VMCCampaignTool from "page/Bimi/Children/VMCCampaignTool";
import DNSTwister from "page/DNSTwister";
import FindLeads from "page/FindLeads";
import CertificateSearch from "page/CertificateSearch";
import DisputeDashboard from "page/DisputeManagement/Children/DisputeDashboard";
import DisputeDashboard1 from "page/DisputeManagement/Children/DisputeDashboard1";
import BoostActions from "page/Crm/Children/BoostAction";
import GeoLeads from "page/Crm/Children/GeoLeads";
import GoalsDashboard from "page/Crm/Children/GoalsDashboard";
import IPAnalysisHub from "page/Crm/Children/IPAnalysisHub";
import JobChangeTracker from "page/Crm/Children/JobChangeTracker";
import LawFirmToolkit from "page/Crm/Children/LawFirmToolKit";
import LeadIntelligence from "page/Crm/Children/LeadIntelligence";
import LegalMarketplaceEnhanced from "page/Crm/Children/LegalMarketplaceEnhanced";
import LegalMarketplace from "page/Crm/Children/LegalMarketPlace";
import MarketplaceAdvanced from "page/Crm/Children/MarketplaceAdvanced";
import MarketplaceEnhancements from "page/Crm/Children/MarketplaceEnhancements";
import PitchMatcher from "page/Crm/Children/PitchMatcher";
import PlaybookRecommender from "page/Crm/Children/PlaybookRecommender";
import ProjectManagementSuite from "page/Crm/Children/ProjectManagementSuite";
import SectorCommunication from "page/Crm/Children/SectorCommunication";
import SmartLeadProcessor from "page/Crm/Children/SmartLeadProcessor";
import SmartScheduler from "page/Crm/Children/SmartScheduler";
import TalentInsights from "page/Crm/Children/TalentInsights";
import TeamLeadsHub from "page/Crm/Children/TeamLeadsHub";
import CRMDashboard from "page/Crm/Children/CrmDashboard";
import CRMDashboard1 from "page/Crm/Children/CRMDashboard1";
import SequenceManager from "page/Crm/Children/SequenceManager";
import SequenceManager1 from "page/Crm/Children/SequenceManager1";


export const AppRoutes = () => {
  return (
    <Routes>
      <Route path={PATHS.CONFLICTCHECK} element={<ConflictCheck />} />
      <Route path={PATHS.HOME} element={<Dashboard />} />
      <Route path={PATHS.PUNNYCODE} element={<DomainAnalysis />} />
      <Route path={PATHS.BLOCKCHAINCERTIFICATION} element={<BlockchainCertification />} />
      <Route path={PATHS.VERIFICATION} element={<AddTradeMark />} />
      <Route path={PATHS.SCHEDULE} element={<Schedule />} />
      <Route path={PATHS.TRAWLSECTION} element={<TrawlSection />} />
      <Route path={PATHS.GAPFILL} element={<GapFill />} />
      <Route path={PATHS.SPECIFICATIONMANAGEMENT} element={<SpecificationManagement />} />
      <Route path={PATHS.BIMIANALYSIS} element={<BimiAnalysis />} />
      <Route path={PATHS.LICENSINGDASHBOARD} element={<LicensingDashboard />} />
      <Route path={PATHS.LICENSINGREMINDERSYSTEM} element={<ReminderSystem />} />
      <Route path={PATHS.LICENSINGSMARTCONTRACT} element={<SmartContract />} />
      <Route path={PATHS.LICENSINGTRADEMARKLICENSE} element={<TrademarkLicense />} />
      <Route path={PATHS.CALCULATORANALYSIS} element={<CurrencyAnalysis />} />
      <Route path={PATHS.CALCULATORENHANCEDVALUATION} element={<EnhancedValuation />} />
      <Route path={PATHS.CALCULATORCOMPREHENSIVEVALUATION} element={<ComprehensiveValuation />} />
      <Route path={PATHS.DETAILEDVALUATIONPRODUCT} element={<Product />} />
      <Route path={PATHS.DETAILEDEBIDTAIMPACTANALYSIS} element={<EBIDTAImpactAnalysis />} />
      <Route path={PATHS.VMCCAMPAIGNTOOL} element={<VMCCampaignTool />} />
      <Route path={PATHS.DNSTWISTER} element={<DNSTwister />} />
      <Route path={PATHS.FINDLEADS} element={<FindLeads />} />
      <Route path={PATHS.CERTIFICATESEARCH} element={<CertificateSearch />} />
      <Route path={PATHS.DISPUTEMANAGEMENTDASHBOARD1} element={<DisputeDashboard />} />
      <Route path={PATHS.DISPUTEMANAGEMENTDASHBOARD2} element={<DisputeDashboard1 />} />
      <Route path={PATHS.CRMBOOSTACTION} element={<BoostActions />} />
      <Route path={PATHS.CRMGEOLEADS} element={<GeoLeads />} />
      <Route path={PATHS.CRMGOALSDASHBOARD} element={<GoalsDashboard />} />
      <Route path={PATHS.CRMIPANALYSISHUB} element={<IPAnalysisHub />} />
      <Route path={PATHS.JOBCHANGETRACKER} element={<JobChangeTracker />} />
      <Route path={PATHS.LAWFIRMTOOLKIT} element={<LawFirmToolkit />} />
      <Route path={PATHS.LEADINTELLIGENCE} element={<LeadIntelligence />} />
      <Route path={PATHS.LEGALMARKETENHANCED} element={<LegalMarketplaceEnhanced />} />
      <Route path={PATHS.LEGALMARKET} element={<LegalMarketplace />} />
      <Route path={PATHS.MARKETPLACEADVANCED} element={<MarketplaceAdvanced />} />
      <Route path={PATHS.MARKETPLACEENHANCEMENTS} element={<MarketplaceEnhancements />} />
      <Route path={PATHS.PITCHMAKER} element={<PitchMatcher />} />
      <Route path={PATHS.PLAYBOOKRECOMMENDER} element={<PlaybookRecommender />} />
      <Route path={PATHS.PROJECTMANAGEMENTSUITE} element={<ProjectManagementSuite />} />
      <Route path={PATHS.SECTORCOMMUNICATION} element={<SectorCommunication />} />
      <Route path={PATHS.SMARTLEADPROCESSOR} element={<SmartLeadProcessor />} />
      <Route path={PATHS.SMARTSCHEDULER} element={<SmartScheduler />} />
      <Route path={PATHS.TALENTINSIGHTS} element={<TalentInsights />} />
      <Route path={PATHS.TEAMLEADSHUB} element={<TeamLeadsHub />} />
      <Route path={PATHS.CRMDASHBOARD} element={<CRMDashboard />} />
      <Route path={PATHS.CRMDASHBOARD1} element={<CRMDashboard1 />} />
      <Route path={PATHS.SEQUENCEMANAGER} element={<SequenceManager />} />
      <Route path={PATHS.SEQUENCEMANAGER1} element={<SequenceManager1 />} />
      <Route path="*" element={<Navigate to={PATHS.HOME} />} />
    </Routes>
  );
};
